import React, { useState } from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, ListItemIcon, Typography } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

import { ICamiseta } from "interfaces/kitsCamiseta";

import { deleteTamanhoCamiseta } from "services/kitsCamiseta";

interface FadeMenuProps {
  kit: ICamiseta;
  openModalAddEdit: (kit: ICamiseta | null) => void;
  updateEvento: () => void;
}

export default function FadeMenu({
  kit,
  updateEvento,
  openModalAddEdit,
}: FadeMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleDeleteItem = async (item: ICamiseta) => {
    await deleteTamanhoCamiseta(item.id);
    updateEvento();
    handleClose();
  };

  const handleOpenModalAddEdit = (kit: ICamiseta | null) => {
    openModalAddEdit(kit);
    handleClose();
  };

  return (
    <div>
      {/* TOOGLE MENU */}
      <IconButton
        id="fade-button"
        aria-label="more"
        aria-controls={open ? "fade-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      {/* MENU */}
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={() => handleDeleteItem(kit)}>
          <ListItemIcon>
            <Delete fontSize="small" color="error" />
          </ListItemIcon>
          <Typography variant="inherit" color="error">
            Excluir
          </Typography>
        </MenuItem>

        <MenuItem onClick={() => handleOpenModalAddEdit(kit)}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          Editar
        </MenuItem>
      </Menu>
    </div>
  );
}
